<template>
    <b-card no-body class="pt-4">
        <FilterDrawer ref="drawer_filter_customer" :agents_list="agentsList" :customer_status_list="customerSubStatusList" @filter_assigned_to="filterAssignedTo($event)" />
        <CustomersAssignToModal :show_assign_customers_to.sync="modals.show_assign_customers_to" :agents_list="agentsList" :customer_details="selectedCustomerRow" :multiple_selection="multipleSelection" :show_ssa="showSSA" :show_sse="showSSE" :show_hub_manager="showHubManager" v-on:closeModal="closeAssignModal()" />
        <CustomerSetStatusModal :show_set_customers_status.sync="modals.show_set_customers_status" :customer_sub_status_list="customerSubStatusList" :multiple_selection="multipleSelection" />
        
        <b-row class="mb-4 mx-3">
            <b-col cols="12" class="px-0 mb-1">
                <p class="font-weight-bold text-muted">Profile Type</p>
            </b-col>
            <b-col cols="6" md="auto" class="px-1">
                <b-button 
                    block
                    :variant="profile_type === 1 ? 'primary' : 'outline-primary'"
                    class="mb-2 mr-2 shadow-none"
                    @click="selectProfileButton(1)"
                >
                    <span class="font-weight-600">All</span><br>
                </b-button>
            </b-col>
            <b-col cols="6" md="auto" class="px-1">
                <b-button 
                    block
                    :variant="profile_type === 2 ? 'primary' : 'outline-primary'"
                    class="mb-2 mr-2 shadow-none"
                    @click="selectProfileButton(2)"
                >
                    <span class="font-weight-600">Single Profile</span><br>
                </b-button>
            </b-col>
            <b-col cols="6" md="auto" class="px-1">
                <b-button 
                    block
                    :variant="profile_type === 3 ? 'primary' : 'outline-primary'"
                    class="mb-2 mr-2 shadow-none"
                    @click="selectProfileButton(3)"
                >
                    <span class="font-weight-600">Joint Profile</span><br>
                </b-button>
            </b-col>
            <b-col cols="6" md="auto" class="px-1">
                <b-button 
                    block
                    :variant="profile_type === 4 ? 'primary' : 'outline-primary'"
                    class="mb-2 mr-2 shadow-none"
                    @click="selectProfileButton(4)"
                >
                    <span class="font-weight-600">Monitoring Profile</span><br>
                </b-button>
            </b-col>
            <b-col cols="6" md="auto" class="px-1">
                <b-button 
                    block
                    :variant="profile_type === 5 ? 'primary' : 'outline-primary'"
                    class="mb-2 mr-2 shadow-none"
                    @click="selectProfileButton(5)"
                >
                    <span class="font-weight-600">Beyond TAT</span><br>
                </b-button>
            </b-col>
        </b-row>

        <b-row class="mb-4 mx-3">
            <b-col cols="12" class="px-0 mb-1" v-if="Object.keys(card_filters).length > 0">
                <p class="font-weight-bold text-muted">Main Status</p>
            </b-col>
            <b-col cols="6" md="auto" class="px-1" v-for="(value, key, index) in card_filters" :key="index">
                <b-button 
                    block
                    :variant="filters.cardStatus === key ? 'primary' : 'outline-primary'"
                    class="mb-2 mr-2 shadow-none"
                    :class="[
                        (['New Leads', 'Missing Status'].includes(key) ? (!_gHlp.checkRoleType( ['admin', 'manager', 'director']) ? 'd-none': '') : ''),
                        (['New Leads', 'Missing Status'].includes(key) && value <= 0 ? 'd-none' : '') 
                    ]"
                    @click="selectFilterButton(key)"
                >
                    <span class="font-weight-600">{{ key }}</span><br>
                    {{ value }}
                </b-button>
            </b-col>
        </b-row>

        <b-col cols="12" v-if="checkIsCorporateSubscription()">
            <b-row class="d-flex align-items-center justify-content-md-end">
                <b-col cols="12" md="3" class="mb-3">
                    <b-button class="float-right px-3 py-2 mb-2 mb-md-0" 
                        variant="outline-secondary" 
                        @click="$refs.drawer_filter_customer.viewFilterCustomer()"
                        
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="#73839C" d="M9 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6.17 5a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1 0-2h1.17zM15 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h7.17zM9 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h1.17z"/></svg>
                        Filters
                    </b-button>
                </b-col>
            </b-row>
        </b-col>

        <b-col cols="12" v-else>
            <b-row class="d-flex align-items-center justify-content-md-start">
                <b-col cols="12" md="3" class="mb-3">
                    <base-input
                            v-model="filters.searchQuery"
                            v-on:input="debouncedHandler"
                            prepend-icon="fas fa-search"
                            placeholder="Search"
                    >   
                    </base-input>
                </b-col>
            </b-row>
        </b-col>
        
        <div class="table-listings">
            <el-alert
                v-if="multipleSelection.length > 0"
                effect="dark"
                class="alert-customer-profile"
                @close="emptySelection"
            >
                <b-row align-h="between" align-v="center">
                    <b-col cols="12" md="4">
                        <p class="text-white">
                            <span class="font-weight-700">{{ multipleSelection.length }}</span> Selected
                        </p>
                    </b-col>
                    <b-col cols="12" md="5" class="d-flex align-items-center" v-if="_gHlp.checkRoleType( ['admin', 'manager', 'director'])">
                        <div class="d-flex align-items-center cursor-pointer mx-3" @click="bulkAssignToModal">
                            <svg xmlns="http://www.w3.org/2000/svg" class="mx-2" width="22" height="14" viewBox="0 0 640 512"><path fill="currentColor" d="M96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"/></svg>
                            <p class="text-white">Assign To</p>
                        </div>
                        <div class="d-flex align-items-center cursor-pointer mx-3" @click="modals.show_set_customers_status = true">
                            <svg xmlns="http://www.w3.org/2000/svg" class="mx-2" width="14" height="18" viewBox="0 0 448 512"><path fill="currentColor" d="M0 80v149.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0l133.5-133.5c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>
                            <p class="text-white">Set Status</p>
                        </div>
                    </b-col>
                </b-row>
            </el-alert>
            <el-table 
                ref="multipleTable"
                v-loading="isTableLoading"
                :data="tableData"
                style="width: 100%"
                @selection-change="selectionChange"
            >
                <el-table-column
                    type="selection"
                    width="35"
                    class-name="individual-table-name px-2"
                ></el-table-column>

                <el-table-column
                    v-if="auth_user.subscription.privileges.scpk_crm_chat_massage"
                    :fixed="isFixed"
                    width="70"
                    class-name="icons-chat"
                >
                    <template slot-scope="scope">
											<MessagingBoxButton :type="'customer'" :profile="scope.row" />
                    </template>
                </el-table-column>

                <el-table-column 
                    :fixed="isFixed"
                    class-name="icons-joint"
                    width="45"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="none" stroke="#DEE5EF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 9h6M4 5h4M6 5v11a1 1 0 0 0 1 1h5m0-9a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1zm0 8a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1z"/></svg>
                </el-table-column>

                <el-table-column
                    prop="name"
                    label="Name/ID"
                    min-width="230"
                    width="auto"
                    :fixed="isFixed"
                    class-name="individual-table-name"
                    sortable
                >
                    <template slot-scope="scope">
                        <div class="d-flex align-items-center justify-content-between">
                            <div >
                                <h3 v-b-tooltip.hover="'Personal'" v-if="scope.row.type === 'Personal'" class="mb-0 mr-3"><b-icon icon="person-fill"></b-icon></h3>
                                <h3 v-b-tooltip.hover="'Company'" v-else-if="scope.row.type === 'Company'" class="mb-0 mr-3"><b-icon icon="building"></b-icon></h3>
                                <h3 v-else class="mr-4 pr-2 mb-0"></h3>
                            </div>
                            <div class="w-100 column-name d-flex align-items-center">
                                <div>
                                    <el-tooltip effect="dark" placement="right">
                                        <div slot="content" class="d-flex align-items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="cursor-pointer" @click.prevent="copyToClipboard(scope.row.name)" width="14" height="18" viewBox="0 0 448 512"><path fill="currentColor" d="M208 0h124.1C344.8 0 357 5.1 366 14.1L433.9 82c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64v256h192v-32h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z"/></svg>
                                        </div>
                                        <router-link :to="'/customerProfileDetails/'+scope.row.customer_id+'?active=overview'">
                                            <p class="font-weight-500 text-primary">{{ scope.row.name | formatUserName(20) }}</p>
                                        </router-link>
                                    </el-tooltip>
                                    <div class="mb-0 bottom-line" v-if="scope.row.corporate != null">{{ scope.row.corporate }}</div>
                                    <span class="mb-0 bottom-line">{{ scope.row.customer_id }}</span>
                                    <i class="fa fa-exclamation-triangle text-danger mx-2 cursor-pointer"
                                        v-if="_gHlp.advisoryListingNeedsSsaWarning(scope.row) && 
                                            _gHlp.checkRoleType( ['admin', 'manager', 'director'])
                                        " @click="assignToModal(scope.row, true, true, true)"></i>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column 
                    width="55" 
                    class-name="text-center"
                    :fixed="isFixed"
                >
                    <template slot-scope="scope">
                        <svg 
                        v-b-tooltip.hover="checkIsCorporateSubscription() ? BASKET_DESCRIPTION[scope.row.basket.basket_color] : ''" 
                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="rounded" :style="{'background': BASKET_COLOR[scope.row.basket.basket_color], 'padding': '0.125rem'}"><path fill="#fff" d="M21 9h-1.42l-3.712-6.496-1.736.992L17.277 9H6.723l3.146-5.504-1.737-.992L4.42 9H3a1.001 1.001 0 0 0-.965 1.263l2.799 10.264A2.005 2.005 0 0 0 6.764 22h10.473c.898 0 1.692-.605 1.93-1.475l2.799-10.263A.998.998 0 0 0 21 9zm-3.764 11v1-1H6.764L4.31 11h15.38l-2.454 9z"/><path fill="#fff" d="M9 13h2v5H9zm4 0h2v5h-2z"/></svg>
                    </template>
                </el-table-column>

                <el-table-column
                    width="120"
                >
                    <template #header>
                        <div class="d-flex flex-column">
                                <div>Product</div>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <el-tooltip v-if="!isEmpty(scope.row.additional_detail)" placement="bottom" effect="dark">
                                <div slot="content">
                                        Product: {{ MAIN_PRODUCTS_LABEL[scope.row.additional_detail.looking_for_product] }}
                                </div>
                                <b-avatar size="32px" :text="_gHlp.formatInitials(MAIN_PRODUCTS_LABEL[scope.row.additional_detail.looking_for_product])"></b-avatar>
                        </el-tooltip>
                        <div v-else>
                                <span style="font-size: 1.5rem">-</span>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="cases"
                    label="Cases"
                    width="100"
                >
                    <template slot-scope="scope" >
                        <svg id="cases-svg" width="50" height="50">
                            <circle cx="25" cy="25" r="18" stroke="#5d79e3" stroke-width="2" fill="#dce2f9" />
                            <text x="25" y="30" text-anchor="middle" fill="#5d79e3" class="cases-text">{{ scope.row.counts.count_product || '0' }}</text>
                        </svg>
                    </template>
                </el-table-column>

                <el-table-column
                    min-width="100"
                    width="auto"
                >
                    <template #header>
                        <div class="d-flex flex-column">
                            <div>Advisory Status</div>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <el-dropdown trigger="click" v-model="customerStatus">
                                    <p class="el-dropdown-link top-line">
                                        <!-- <span :class="getRandomStatus().class">{{ getRandomStatus().value }}</span> -->
                                        <span v-if="scope.row.loan_advisory_status && scope.row.loan_advisory_status.sub.status != null" v-b-tooltip.hover="scope.row.loan_advisory_status.sub.status">{{ scope.row.loan_advisory_status.sub.status | shortenText(16) }}</span>
                                        <span v-else>-</span>

                                        <i class="el-icon-caret-bottom el-icon--right"></i>
                                    </p>
                                    <el-dropdown-menu slot="dropdown" >
                                        <div style="max-height: 300px;overflow-y: auto;">
                                            <el-dropdown-item v-for="status in loanAdvisorySubStatusList" :key="status.status_id" @click.native="updateCustomerAdvisoryStatus(scope.row.customer_id,status.status_id)">
                                                <span class="font-weight-bold">{{status.parent_status}}</span> - {{ status.status }}
                                            </el-dropdown-item>
                                        </div>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                
                <el-table-column
                    prop="status"
                    label="Sub Status"
                    min-width="200"
                    width="auto"
                    sortable
                >
                    <template slot-scope="scope">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <el-dropdown trigger="click" v-model="customerStatus">
                                    <p class="el-dropdown-link top-line">
                                        <!-- <span :class="getRandomStatus().class">{{ getRandomStatus().value }}</span> -->
                                        <span v-if="scope.row.status" v-b-tooltip.hover="scope.row.status.sub.status">{{ scope.row.status.sub.status | shortenText(16) }}</span>
                                        <span v-else>-</span>

                                        <i class="el-icon-caret-bottom el-icon--right"></i>
                                    </p>
                                    <el-dropdown-menu slot="dropdown" >
                                        <div style="max-height: 300px;overflow-y: auto;">
                                            <el-dropdown-item v-for="status in customerSubStatusList" :key="status.status_id" @click.native="updateCustomerStatus(scope.row.customer_id,status.status_id)">
                                                <span class="font-weight-bold">{{status.parent_status}}</span> - {{ status.status }}
                                            </el-dropdown-item>
                                        </div>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <div>
                                <el-popover
                                    v-if="!isEmpty(scope.row.status.tat_summary) && !isEmpty(scope.row.status.tat_summary.tat_at)"
                                    placement="top-start"
                                    title="Date Tracking"
                                    trigger="hover">
                                    <p v-if="isEmpty(scope.row.status.tat_summary.tat_stop_at)">
                                            <small class="mb-0 d-block">Last Update : {{scope.row.status.tat_summary.tat_at | dateFormatString}}</small>
                                            <small class="mb-0 d-block" :style="{'color': scope.row.status.tat_summary.tat_color}">Due Date : {{scope.row.status.tat_summary.due_at | dateFormatString}}</small>
                                            <small class="mb-0 d-block" :style="{'color': scope.row.status.tat_summary.tat_color}">{{scope.row.status.tat_summary.remain_label}}</small>
                                    </p>
                                    <p v-else>
                                            <small class="mb-0 d-block">Create Date : {{scope.row.status.tat_summary.tat_created_at | dateFormatString}}</small>
                                            <small class="mb-0 d-block">Stop Date : {{scope.row.status.tat_summary.tat_stop_at | dateFormatString}}</small>
                                            <small class="mb-0 d-block"><strong>TOTAL : {{scope.row.status.tat_summary.tat_total}} Days</strong></small>
                                    </p>
                                    <i slot="reference" class="el-icon-info" :style="{'color': scope.row.status.tat_summary.tat_color}"></i>
                                </el-popover>
                            </div>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="incomes.main.net_income"
                    min-width="180"
                    width="auto"
                    sortable
                    :sort-by="customSortKey"
                >
                <template #header>
                    <div class="d-flex flex-column">
                        <div>Net Income</div>
                        <div>/Commit (DSR)</div>
                    </div>
                </template>
                    <template slot-scope="scope">
                        <p class="mb-0 top-line">RM {{  (Number(scope.row.incomes ? scope.row.incomes.main.net_income : '0' | moneyFormatter)) }}</p>
                        <p class="mb-0 bottom-line">RM {{ scope.row.incomes ? scope.row.incomes.main.total_commitment : '0' | moneyFormatter }} &nbsp;({{ scope.row.incomes ? (scope.row.incomes.main.dsr ? scope.row.incomes.main.dsr+'%' : '0.00%' )  : '0.00%' }})
                        </p>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="created_by"
                    label="Created By"
                    width="120"
                >
                <template slot-scope="scope">
                        <el-tooltip v-if="scope.row.created_by_detail" placement="bottom" effect="dark">
                            <div slot="content">
                                Name: {{ scope.row.created_by_detail.name }}
                            </div>
                            <b-avatar size="32px" :src="scope.row.created_by_detail.avatar_url" :text="_gHlp.formatInitials(scope.row.created_by_detail.name)"></b-avatar>
                        </el-tooltip>
                        <div v-else>
                            <span style="font-size: 1.5rem">-</span>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="hub_manager"
                    label="Hub Manager"
                    min-width="90"
                    width="auto"
                >
                    <template slot-scope="scope">
                        <el-tooltip v-if="scope.row.hub_manager" placement="bottom" effect="dark">
                            <div slot="content">
                                    Name: {{ scope.row.hub_manager.name }}
                            </div>
                            <b-avatar class="cursor-pointer" size="32px" :src="scope.row.hub_manager.avatar_url" :text="_gHlp.formatInitials(scope.row.hub_manager.name)" @click.native="assignToModal(scope.row, false, false, true)"></b-avatar>
                        </el-tooltip>
                        <div v-else>
                            <span style="font-size: 1.5rem">-</span>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="assigned_to"
                    label="TM"
                    min-width="90"
                    width="auto"
                >
                    <template slot-scope="scope">
                        <el-tooltip v-if="scope.row.se" placement="bottom" effect="dark">
                            <div slot="content">
                                Name: {{ scope.row.se.name }}
                            </div>
                            <b-avatar size="32px" :src="scope.row.se.avatar_url" :text="_gHlp.formatInitials(scope.row.se.name)"></b-avatar>
                        </el-tooltip>
                        <div v-else>
                            <span style="font-size: 1.5rem">-</span>
                        </div>
                    </template>
                </el-table-column>


                <el-table-column
                    prop="SSA"
                    label="SSA"
                    min-width="90"
                    width="auto"
                >
                    <template slot-scope="scope">
                        <el-tooltip v-if="scope.row.ssa" placement="bottom" effect="dark">
                            <div slot="content">
                                    Name: {{ scope.row.ssa.name }}
                            </div>
                            <b-avatar class="cursor-pointer" size="32px" :src="scope.row.ssa.avatar_url" :text="_gHlp.formatInitials(scope.row.ssa.name)" @click.native="assignToModal(scope.row, true, false)"></b-avatar>
                        </el-tooltip>
                        <div v-else>
                            <span style="font-size: 1.5rem">-</span>
                        </div>
                    </template>
                </el-table-column>
                
                <el-table-column
                    prop="SSE"
                    label="SSE"
                    min-width="90"
                    width="auto"
                >
                    <template slot-scope="scope">
                        <el-tooltip v-if="scope.row.sse" placement="bottom" effect="dark">
                            <div slot="content">
                                Name: {{ scope.row.sse.name }}
                            </div>
                            <b-avatar class="cursor-pointer" size="32px" :src="scope.row.sse.avatar_url" :text="_gHlp.formatInitials(scope.row.sse.name)" @click.native="assignToModal(scope.row, false, true)"></b-avatar>
                        </el-tooltip>
                        <div v-else>
                            <span style="font-size: 1.5rem">-</span>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    min-width="200"
                    width="auto"
                    prop="channel.name"
                    sortable
                >
                    <template #header>
                        <div class="d-flex flex-column">
                            <div>Channel</div>
                            <div>/Platform</div>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div class="d-flex align-items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M12 17a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z"/></svg>
                            <p class="mb-0 top-line" v-if="scope.row.channel">{{ scope.row.channel.name }}</p>
                            <p class="mb-0 top-line" v-else>N/A</p>
                        </div>
                        <div class="d-flex align-items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M12 17a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z"/></svg>
                            <p class="mb-0 bottom-line" v-if="scope.row.platform">{{ scope.row.platform.name }}</p>
                            <p class="mb-0 bottom-line" v-else>N/A</p>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="address"
                    min-width="190"
                    width="auto"
                >
                    <template #header>
                        <div class="d-flex flex-column">
                            <div>Created Date</div>
                            <div>/TAT</div>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <p class="mb-0 top-line" v-if="scope.row.created_at">{{ scope.row.created_at | dateFormatString }}</p>
                        <p v-else>-</p>
                        <p class="mb-0 bottom-line" v-if="!isEmpty(scope.row.status.tat_summary) && !isEmpty(scope.row.status.tat_summary.tat_at)">
                            <el-popover
                                v-if="!isEmpty(scope.row.status.tat_summary) && !isEmpty(scope.row.status.tat_summary.tat_at)"
                                placement="top-start"
                                title="Date Tracking"
                                trigger="hover">
                                <p v-if="isEmpty(scope.row.status.tat_summary.tat_stop_at)">
                                        <small class="mb-0 d-block">Last Update : {{scope.row.status.tat_summary.tat_at | dateFormatString}}</small>
                                        <small class="mb-0 d-block" :style="{'color': scope.row.status.tat_summary.tat_color}">Due Date : {{scope.row.status.tat_summary.due_at | dateFormatString}}</small>
                                        <small class="mb-0 d-block" :style="{'color': scope.row.status.tat_summary.tat_color}">{{scope.row.status.tat_summary.remain_label}}</small>
                                </p>
                                <p v-else>
                                        <small class="mb-0 d-block">Create Date : {{scope.row.status.tat_summary.tat_created_at | dateFormatString}}</small>
                                        <small class="mb-0 d-block">Stop Date : {{scope.row.status.tat_summary.tat_stop_at | dateFormatString}}</small>
                                        <small class="mb-0 d-block"><strong>TOTAL : {{scope.row.status.tat_summary.tat_total}} Days</strong></small>
                                </p>
                                <i slot="reference" class="el-icon-info" :style="{'color': scope.row.status.tat_summary.tat_color}"></i>
                            </el-popover>
                            {{ (!isEmpty(scope.row.status.tat_summary.tat_stop_at) ?  scope.row.status.tat_summary.tat_stop_at : scope.row.status.tat_summary.tat_at) | dateFormatString }}
                        </p>
                        <p v-else>-</p>
                    </template>
                </el-table-column>
                
                <el-table-column
                    fixed="right"
                    width="20"
                    class-name="px-1"
                >
                    <template slot-scope="scope">
                        <p class="mb-0 top-line">
                            <b-icon icon="three-dots-vertical"></b-icon>
                        </p>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap"
        >
            <div class="d-flex align-items-center mb-3">
                <p class="card-category mb-0 text-secondary">
                    Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries
        
                    <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                    </span>
                </p>

                <span class="mb-0 ml-4">Rows:</span>

                <el-select
                    class="select-primary pagination-select mx-2"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                    @change="perPageChanged"
                >
                    <el-option
                        class="select-primary"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    >
                    </el-option>
                </el-select>
    
            </div>
            <base-pagination
                class="pagination-no-border"
                :current="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
                @change="paginationChanged($event)"
            >
            </base-pagination>
        </div>

    </b-card>
</template>
<script>
    import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip, Popover, Select, Option, Button, Badge, Tag, DatePicker, Alert } from 'element-ui'
    import { BasePagination } from '@/components'
    import { useAuthStore } from '@/stores/authStore'
    import { useCustomerStore } from '@/stores/customerStore'
    import { useConfigStore } from '@/stores/configStore';
		import { useMessagingStore } from '@/stores/messagingStore'
    import { mapState, mapActions } from 'pinia'
    import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
    import {
        notifyFunctionMixin,
        axios,
        services,
        getHeader,
        debounce
    } from '@/assets/js/httpImports.js'
    import {BASKET_COLOR} from '@/assets/js/colors.js'
    import mainEventBus from '@/assets/js/mainEventBus'
    import MessagingBoxButton from '@/views/Messaging/MessagingBoxButton'
    import helperFunctionMixin from '@/assets/js/helperFunctionMixin'
    import FilterDrawer from '@/views/CustomerProfile/CustomerProfileListings/FilterDrawer'
    import CustomersAssignToModal from '@/views/CustomerProfile/CustomerModals/CustomerTable/CustomersAssignToModal'
    import CustomerSetStatusModal from '@/views/CustomerProfile/CustomerModals/CustomerTable/CustomerSetStatusModal'
    import { CAN_ASSIGN_ROLE_IDS } from '@/assets/js/roles.js' 
    import {BASKET_DESCRIPTION, MAIN_PRODUCTS_LABEL} from '@/assets/js/status.js'

    export default {
        mixins: [notifyFunctionMixin, clientPaginationMixin, helperFunctionMixin],
        components: {
            BasePagination,
            MessagingBoxButton,
            FilterDrawer,
            CustomersAssignToModal,
            CustomerSetStatusModal,
            [Select.name]: Select,
            [Option.name]: Option,
            [Tooltip.name]: Tooltip,
            [Popover.name]: Popover,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Badge.name]: Badge,
            [Tag.name]: Tag,
            [DatePicker.name]: DatePicker,
            [Alert.name]: Alert,
        },
        computed: {
            ...mapState(useAuthStore,['auth_user']),
            ...mapState(useConfigStore,['app_code']),
        },
        data() {
            return {
                isTableLoading: true,
                BASKET_DESCRIPTION:BASKET_DESCRIPTION,
                MAIN_PRODUCTS_LABEL:MAIN_PRODUCTS_LABEL,
                BASKET_COLOR:BASKET_COLOR,
                propsToSearch:['name'],
                isFixed: true,
                currentPage: 1,
                mode: 'listing',
                selectedRows: [],
                searchText: '',
                debouncedHandler: '',
                TableColumn:[{
                    type: 'selection'
                }],
                
                status: [],
                selects: {
                    filter: [],
                },
                filterOptions:[],
                filterBy: '',
                tableData: [],
                randomStatus: null,
                loanAdvisorySubStatusList:[],
                customerSubStatusList: [],
                customerStatus: "NA",
                card_filters:[],
                selectedDates:[],
                multipleSelection: [],
                modals: {
                    show_assign_customers_to: false,
                    show_set_customers_status: false
                },
                agentsList: [],
                selectedCustomerRow: {},
                showSSA: true,
                showSSE: false,
                showHubManager: false,
                filters: {
                    monitoring:'',
                    beyond_tat:'',
                    customer_id: "",
                    customer_name: "",
                    income_type_id: "",
                    status: "",
                    se: "",
                    ssa: "",
                    sse: "",
                    cardStatus: "All",
                    searchQuery: "",
                    created_at: "",
                    updated_at: "",
                    end_date: "",
                    channel:"",
                    platform:"",
                    is_joint:"",
                    corporate:"",
                },
                profile_type: 1,
                pagination:{
                    perPageOptions: [5, 10, 25, 50, 100, 500]
                },
            };
        },
        async created(){
            if (this.app_code === 'dahongye') {
                this.pagination.perPage = 50
            } else {
                this.pagination.perPage = 25
            }
            
            this.getCustomers()
            this.getLoanAdvisoryStatus()
            this.agentsList = await this.getUserList()
        },
        mounted() {
            this.setFixed();
            window.addEventListener('resize', this.setFixed);
            mainEventBus.$on('refresh-table-data', this.refreshTableData)
            this.debouncedHandler = debounce(() => {
                this.selectedFilterButton = 'All'
                this.getCustomers();
            }, 500);

        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setFixed);
        },
        beforeUnmount() {
            mainEventBus.$off('refresh-table-data', this.refreshTableData)
        },
        methods: {
            ...mapActions(useCustomerStore, ['getCustomerCount']),
						...mapActions(useMessagingStore, ['getProfileListMessagesSummaries']),
            getCustomers(){
                this.isTableLoading = true
                axios.get(services.customer + 'customers', {
                    params: {
                        paginate: this.pagination.perPage,
                        page: this.pagination.currentPage,
                        customer_id: this.filters.customer_id,
                        name: this.filters.customer_name,
                        status: this.filters.status,
                        channel: this.filters.channel,
                        platform: this.filters.platform,
                        ssa: this.filters.ssa,
                        se: this.filters.se,
                        sse: this.filters.sse,
                        filter: this.filters.searchQuery,
                        cards: this.filters.cardStatus,
                        created_at: this.filters.created_at,
                        updated_at: this.filters.updated_at,
                        nric: this.filters.nric,
                        income_type_id: this.filters.income_type_id,
                        monitoring: this.filters.monitoring,
                        beyond_tat: this.filters.beyond_tat,
                        is_joint: this.filters.is_joint,
                        corporate: this.filters.corporate,
                        send_to_advisory: 1,
                    },
                    headers: getHeader()})
                    .then(res => {
                      console.log(res)
                        this.current_customer_ids = []
                        const data = res.data.data.data
                        this.isTableLoading = false
                        this.tableData = data
                        this.pagination.currentPage = res.data.data.meta.current_page
                        this.pagination.perPage = Number(res.data.data.meta.per_page)
                        this.pagination.total = res.data.data.meta.total
                        this.pagination.from = res.data.data.meta.from
                        this.pagination.to = res.data.data.meta.to
                        this.pagination.to = res.data.to
                        for(let i = 0; i < data.length; i++){
                            this.current_customer_ids.push(data[i].customer_id)
                        }
												this.getProfileListMessagesSummaries('customer',this.tableData);
                    })
                    .catch(e => {
                        this.isTableLoading = false
                        this.errorFunction(e)
                    })
            },
            selectionChange(selectedRows) {
                this.selectedRows = selectedRows
                this.multipleSelection = selectedRows
            },
            emptySelection() {
                this.$refs.multipleTable.clearSelection()
            },
            paginationChanged(page)
            {
                this.pagination.currentPage = page
                this.getCustomers()
            },
            perPageChanged()
            {
                this.pagination.currentPage = 1
                this.getCustomers()
            },
            customSortKey(row) {
                return parseFloat(row.incomes.main.net_income);
            },
            assignToModal(customerAssigned, showSSA, showSSE, showHubManager = false) {
                this.modals.show_assign_customers_to = true
                this.selectedCustomerRow = customerAssigned
                this.showSSA = showSSA
                this.showSSE = showSSE
                this.showHubManager = showHubManager
                this.$refs.multipleTable.clearSelection()
            },
            bulkAssignToModal() {
                this.modals.show_assign_customers_to = true
                this.selectedCustomerRow = {}
                this.showSSA = true
                this.showSSE = true
                this.showHubManager = true
            },
            refreshTableData() {
                this.modals = {
                    show_assign_customers_to: false,
                    show_set_customers_status: false,
                    show_create_joint_customer: false
                },
                this.tableData = []
                this.getCustomers()
                this.getCustomerCountHandler()
            },
            closeAssignModal() {
                this.showSSA = true
                this.showSSE = true
            },
            copyToClipboard(customer) {
                let value = null
                if(customer.cjp_id){
                    customer.customer_joint_profiles.forEach((item) => {
                        if(!value){
                            value = item.name
                        }else{
                            value = value + '+' + item.name
                        }
                    })
                }else{
                    value = customer.name
                }
                const tempInput = document.createElement('input');
                tempInput.value = value;
                document.body.appendChild(tempInput);
                tempInput.select();
                document.execCommand('copy');
                document.body.removeChild(tempInput);

                // this.notifySuccess('<b>Customer Name:</b> Copied to Clipboard')
                this.notifySuccess('<b>Customer Name:</b> '+value+'<br>Copied to Clipboard.')
            },
            async getCustomerCountHandler(){
                try{
                    const res = await this.getCustomerCount({
                        customer_id: this.filters.customer_id,
                        name: this.filters.customer_name,
                        status: this.filters.status,
                        channel: this.filters.channel,
                        platform: this.filters.platform,
                        ssa: this.filters.ssa,
                        se: this.filters.se,
                        sse: this.filters.sse,
                        filter: this.filters.searchQuery,
                        cards: this.filters.cardStatus,
                        created_at: this.filters.created_at,
                        updated_at: this.filters.updated_at,
                        nric: this.filters.nric,
                        monitoring: this.filters.monitoring,
                        beyond_tat: this.filters.beyond_tat,
                        is_joint: this.filters.is_joint,
                        corporate:this.filters.corporate
                    })
                    this.card_filters = res.data.data.count
                }catch(e){
                    this.errorFunction(e)
                }
            },
            selectProfileButton(index){
                this.profile_type = index
                if(index === 1){
                    this.filters.is_joint = ''
                    this.filters.monitoring = ''
                    this.filters.beyond_tat = ''
                }
                if(index === 2){
                    this.filters.is_joint = 0
                    this.filters.monitoring = ''
                    this.filters.beyond_tat = ''
                }
                if(index === 3){
                    this.filters.is_joint = 1
                    this.filters.monitoring = ''
                    this.filters.beyond_tat = ''
                }
                if(index === 4){
                    this.filters.is_joint = ''
                    this.filters.monitoring = 1
                    this.filters.beyond_tat = ''
                }
                if(index === 5){
                    this.filters.is_joint = ''
                    this.filters.monitoring = ''
                    this.filters.beyond_tat = 1
                }
                this.filters.cardStatus = 'All'
                this.pagination.currentPage = 1
                this.sub_status = []
                this.getCustomers()
            },
            setFixed() {
                this.isFixed = window.innerWidth > 768;
            },
            refreshTableData() {
                this.modals = {
                    show_assign_customers_to: false,
                    show_set_customers_status: false
                },
                this.tableData = []
                this.getCustomers()
            },
            filterAssignedTo(event) {
                console.log(event)
                if(event.date_type == 1) {
                    this.filters.updated_at = ''
                    this.filters.created_at  = event.date_range
                }else if(event.date_type == 2) {
                    this.filters.created_at = ''
                    this.filters.updated_at  = event.date_range
                }else {
                    this.filters.created_at = ''
                    this.filters.updated_at = ''
                }
                this.filters.se = event.se
                this.filters.ssa = event.ssa
                this.filters.sse = event.sse
                this.filters.customer_name = event.customer_name
                this.filters.customer_id = event.customer_id
                this.filters.status = event.status
                this.filters.end_date = event.end_date
                this.filters.channel = event.channel
                this.filters.platform = event.platform
                this.filters.nric = event.nric
                this.filters.income_type_id =  event.income_type_id,
                this.filters.cardStatus = 'All'
                this.getCustomers()
            },
            getCustomerStatus() {
                axios.get(services.customer + 'customer/statuses', {headers: getHeader()})
                .then(res => {
                    this.customerSubStatusList = res.data.data
                        .filter((status) => status.group == "sub" ? status : "")
                        .sort(function(a, b) {
                            if(a.parent_status && b.parent_status){
                                if (a.parent_status < b.parent_status) {
                                    return -1;
                                }
                                if (a.parent_status > b.parent_status) {
                                    return 1;
                                }
                            }
                            return 0;
                        })
                    this.customerStatusList = res.data.data
                })
                .catch(e => {
                    this.errorFunction(e)
                })
            },
            updateCustomerStatus(customer_id, status_id) {
                axios.put(services.customer + 'customer/' + customer_id + '/status/' + status_id, {}, { headers: getHeader() })
                    .then(res => {
                        this.tableData = []
                        this.getCustomers()
                        this.getCustomerCountHandler()
                        this.notifySuccess('<b>Customer Status - Successfully Updated.')
                    })
                    .catch(e => {
                        this.errorFunction(e)
                    })
            },
            getLoanAdvisoryStatus(){
                axios.get(services.lookup + 'loan_advisory_status', {headers: getHeader()})
                .then(res => {
                    this.loanAdvisorySubStatusList = res.data.data.filter((item) => item.group === 'sub')
                })
                .catch(e => {
                    this.errorFunction(e)
                })
            },
            updateCustomerAdvisoryStatus(customer_id, status_id) {
                axios.put(services.customer + 'customer/' + customer_id + '/loan_advisory_status/' + status_id, {}, { headers: getHeader() })
                    .then(res => {
                        this.tableData = []
                        this.getCustomers()
                        this.notifySuccess('<b>Customer Loan Advisory Status - Successfully Updated.')
                    })
                    .catch(e => {
                        this.errorFunction(e)
                    })
            },
            
        }
    }
</script>